var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 12C9.15685 12 10.5 10.6569 10.5 9C10.5 7.34315 9.15685 6 7.5 6C5.84315 6 4.5 7.34315 4.5 9C4.5 10.6569 5.84315 12 7.5 12ZM7.5 10.7143C8.44677 10.7143 9.21429 9.94677 9.21429 9C9.21429 8.05323 8.44677 7.28571 7.5 7.28571C6.55323 7.28571 5.78571 8.05323 5.78571 9C5.78571 9.94677 6.55323 10.7143 7.5 10.7143Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0596 13.5733C9.29508 13.2072 8.42416 13 7.5 13C4.46243 13 2 15.2386 2 18C2 18.4441 2 18.7567 2.14271 18.9767C2.48204 19.5 3.62826 19.5 7.5 19.5C7.75776 19.5 8.00344 19.5 8.23761 19.4998C8.09964 19.2027 8.04891 18.9185 8.02575 18.7063C7.99974 18.468 7.99988 18.2147 7.99999 18.0328L8 18H3.32C3.32 16.067 5.19145 14.5 7.5 14.5C8.03748 14.5 8.55127 14.5849 9.02327 14.7397C9.31726 14.3142 9.66636 13.9241 10.0596 13.5733Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 12C17.683 12 19.25 10.433 19.25 8.5C19.25 6.567 17.683 5 15.75 5C13.817 5 12.25 6.567 12.25 8.5C12.25 10.433 13.817 12 15.75 12ZM15.75 10.5C16.8546 10.5 17.75 9.60457 17.75 8.5C17.75 7.39543 16.8546 6.5 15.75 6.5C14.6454 6.5 13.75 7.39543 13.75 8.5C13.75 9.60457 14.6454 10.5 15.75 10.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8648 18.9369C22 18.7194 22 18.4179 22 18C22 15.2386 19.2018 13 15.75 13C12.2982 13 9.5 15.2386 9.5 18C9.5 18.4179 9.5 18.7194 9.63515 18.9369C9.98512 19.5 11.2413 19.5 15.75 19.5C20.2587 19.5 21.5149 19.5 21.8648 18.9369ZM20.5 18C20.5 16.067 18.3734 14.5 15.75 14.5C13.1266 14.5 11 16.067 11 18H20.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.16d91c75.svg";
export { ForwardRef as ReactComponent };